import { render, staticRenderFns } from "./PriceApprove.vue?vue&type=template&id=528be70e&"
import script from "./PriceApprove.vue?vue&type=script&lang=js&"
export * from "./PriceApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports